export default "__VITE_ASSET__DbbmiqDO__"